import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../assets/img/share.jpg'


const _hoisted_1 = { class: "share-wrapper" }
const _hoisted_2 = { class: "share-flex" }
const _hoisted_3 = {
  key: 1,
  class: "share-content"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  class: "share-pic",
  src: _imports_0
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "share-btn",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showPop = true))
      }),
      (_ctx.showSave)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: "save-btn",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.saveClick && _ctx.saveClick(...args)))
          }))
        : _createCommentVNode("", true)
    ]),
    (_ctx.showPop)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: "share-popup",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showPop = false))
        }))
      : _createCommentVNode("", true),
    (_ctx.showPop)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _hoisted_4
        ]))
      : _createCommentVNode("", true)
  ]))
}